export enum MarkupType {
  Mobile,
  Tablet,
  Desktop,
  Adaptive,
}
